import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { importProvidersFrom } from '@angular/core';
import { AuthModule } from 'angular-auth-oidc-client';
import { openIdConfig } from './app/auth-config';
//import '@grupodemarco/dm-notification-center-sdk';

registerLocaleData(localePt, 'pt-BR');

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    importProvidersFrom(
      AuthModule.forRoot({
        config: openIdConfig,
      })
    ),
    ...appConfig.providers!,
  ]
}).catch(err => {
  console.error('Erro ao iniciar aplicação:', err);
});